import { motion } from 'framer-motion'
import { CircleCheck } from 'lucide-react'

interface CheckCircleProps {
  size?: number
  text?: string
}

export function CheckCircle({ size = 16, text = '' }: CheckCircleProps) {
  return (
    <motion.div {...containerAnimation} className="flex items-center gap-2">
      <motion.div {...tickAnimation} className={'text-green'}>
        <CircleCheck size={size} />
      </motion.div>
      <motion.p className={'text-green'} {...textAnimation}>
        {text}
      </motion.p>
    </motion.div>
  )
}

const containerAnimation = {
  initial: { opacity: 0, scale: 0.8 },
  animate: { opacity: 1, scale: 1 },
  transition: { duration: 0.3 },
}

const textAnimation = {
  initial: { x: -10, opacity: 0 },
  animate: { x: 0, opacity: 1 },
  transition: { duration: 0.3, delay: 0.2 },
}

const tickAnimation = {
  initial: { rotate: -90 },
  animate: { rotate: 0 },
  transition: { duration: 0.3, delay: 0.1 },
}
